import { AppDispatch, RootState } from './store';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Connect, connect, useDispatch, useSelector } from 'react-redux';

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const appConnect = connect as Connect<RootState>;
